import {
  FEATURED_DEALS_VIEW, MY_ACCOUNT_FEATURED_DEALS_VIEW, FEATURED_DEALS_HEADING_FILL,
} from './types';

export const fillFeaturedDealsHeading = payload => ({
  type: FEATURED_DEALS_HEADING_FILL,
  payload,
});

export const triggerFeaturedDealsIsViewed = deals => ({
  type: FEATURED_DEALS_VIEW,
  deals,
});

export const triggerMyAccountFeaturedDealsIsViewed = deals => ({
  type: MY_ACCOUNT_FEATURED_DEALS_VIEW,
  deals,
});
